import { useState } from "react";
import SearchFilter from "../../components/SearchFilter";
import CustomButton from "../../components/CustomButton";
import CustomInput from "../../components/CustomInput";
import Dropdown from "../../components/Dropdown";
import CustomCheckbox from "../../components/CustomCheckbox";
import CompanySupplierFilter from "./CompanySupplierFilter";
import filterIcon from "../../assets/filter-icon.png";
import FilterButton from "../../components/FilterButton";

const BanksInvoicesApplicationsFilters = ({
  t,
  loading,
  selectedReceiver,
  setSelectedReceiver,
  selectedSender,
  setSelectedSender,
  myTransactions,
  setMyTransactions,
  searchTitles,
  selectedTitle,
  handleSearchType,
  searchQuery,
  setSearchQuery,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  selectedStatus,
  setSelectedStatus,
  statusOptions,
  payemntsStatus,
  handleSearch,
  formatDate,
  includeCompleted,
  setIncludeCompleted,
  includeRejected,
  setIncludeRejected,
  includeAppsNotPassedByMaker,
  setIncludeAppsNotPassedByMaker,
  setPagination,
}) => {
  const isAuditor = localStorage.getItem("role") === "applicationsAuditor";
  const [isFiltersOpen, setIsFiltersOpen] = useState(false);

  return (
    <>
      {/* Filters Toggle Button */}
      <button
        className="c-search-filter u-margin--bottom_500 u-margin--top_500"
        onClick={() => setIsFiltersOpen(!isFiltersOpen)}
      >
        {/*<span className="toggle-icon">{isFiltersOpen ? "▼" : "▶"}</span>*/}
        {/*<span className="toggle-text">{t("filters")}</span>*/}

        <div
          tabIndex={0} // Make the dropdown toggle focusable
          className={`toggle ${isFiltersOpen ? "opened" : ""} ${isFiltersOpen ? "thick" : ""}`}
        >
          <FilterButton t={t} isFiltersOpen={isFiltersOpen} />
        </div>
      </button>

      {/* Filters Content */}
      {isFiltersOpen && (
        <div className="filters-content">
          {/* Company & Supplier Filter Section */}
          <div className="u-margin--bottom_500">
            <CompanySupplierFilter
              onCompanyChange={(company) => {
                setSelectedSender(company);
                setPagination((prev) => ({ ...prev, currentPage: 1 }));
              }}
              onSupplierChange={(supplier) => {
                setSelectedReceiver(supplier);
                setPagination((prev) => ({ ...prev, currentPage: 1 }));
              }}
              myTransactions={myTransactions}
              setMyTransactions={setMyTransactions}
              disabled={loading}
              companyTitle="sender"
              supplierTitle="receiver"
            />
          </div>

          {/* Advanced Search Section */}
          <div className="c-search-bar u-margin--bottom_500">
            <section className="c-search-bar-label-input">
              <label>
                {t("searchTitle")} {t(selectedTitle?.title)}:
              </label>
              {selectedTitle.value === "date" ||
              selectedTitle.value === "paymentsDate" ? (
                <div className="o-column-row-switcher o-column--gap-size_300">
                  <CustomInput
                    name="startDate"
                    title={t("from")}
                    type="date"
                    thick
                    onChange={(date) => {
                      setStartDate(date?.target?.value);
                    }}
                    resetSearch={() => {
                      setStartDate("");
                    }}
                    value={formatDate(startDate)}
                  />
                  <CustomInput
                    name="endDate"
                    title={t("to")}
                    type="date"
                    thick
                    onChange={(date) => {
                      setEndDate(date?.target?.value);
                    }}
                    resetSearch={() => {
                      setEndDate("");
                    }}
                    value={formatDate(endDate)}
                  />
                </div>
              ) : selectedTitle.value === "status" ? (
                <>
                  <Dropdown
                    options={statusOptions}
                    selected={selectedStatus}
                    setSelected={setSelectedStatus}
                    thick
                    nameInAr={true}
                  />
                </>
              ) : selectedTitle.value === "paymentsStatus" ? (
                <>
                  <Dropdown
                    options={payemntsStatus}
                    selected={selectedStatus}
                    setSelected={setSelectedStatus}
                    thick
                    nameInAr={true}
                  />
                </>
              ) : (
                <div className="u-width--min-width_230">
                  <CustomInput
                    placeholder={`${t("searchTitle")} ${t(selectedTitle?.title)}`}
                    value={searchQuery}
                    onChange={(e) => {
                      setSearchQuery(e.target.value);
                    }}
                    resetSearch={() => {
                      setSearchQuery("");
                      handleSearch("");
                    }}
                    thick
                    flex
                  />
                </div>
              )}
            </section>
            <div className="o-row o-row--gap-size_400">
              <SearchFilter
                options={searchTitles}
                selected={selectedTitle}
                setSelected={handleSearchType}
                thick
              />
              <CustomButton
                title={t("search")}
                onClick={handleSearch}
                icon="search"
                iconSize={15}
              />
            </div>
          </div>

          {/* Checkboxes Section */}

          <div className={"o-column o-column--gap-size_50 u-margin--bottom_500"}>
            <div className="o-row o-row--vertical-align_center o-row--gap-size_200 ">
              <CustomCheckbox
                  checked={includeCompleted}
                  onClick={() => {
                    setIncludeCompleted((prev) => !prev);
                    setPagination((prev) => ({ ...prev, currentPage: 1 }));
                  }}
              />
              <span>{t("includeCompletedApplications")}</span>
            </div>

            <div className="o-row o-row--vertical-align_center o-row--gap-size_200">
              <CustomCheckbox
                  checked={includeRejected}
                  onClick={() => {
                    setIncludeRejected((prev) => !prev);
                    setPagination((prev) => ({ ...prev, currentPage: 1 }));
                  }}
              />
              <span>{t("includeRejectedApplications")}</span>
            </div>

            {isAuditor && (
                <div className="o-row o-row--vertical-align_center o-row--gap-size_200 ">
                  <CustomCheckbox
                      checked={includeAppsNotPassedByMaker}
                      onClick={() => {
                        setIncludeAppsNotPassedByMaker((prev) => !prev);
                        setPagination((prev) => ({ ...prev, currentPage: 1 }));
                      }}
                  />
                  <span>{t("includeAppsNotPassedByMaker")}</span>
                </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default BanksInvoicesApplicationsFilters;
